import $ from 'jquery';

let elements = [];

$(function () {
    
    $('.statisticspanel .statistic').each(function (i, e) {
		elements[elements.length] = { top: $(e).offset().top, elem: e, started: false };        

		// Set position of the suffix
		let $h4 = $(e).find('.h4');
		let sup = $h4.find('sup');
		if (sup.length) {
			$(sup).css('left', ($h4.outerWidth() + 18) + 'px');
			$h4.css('padding-right', $(sup).width() + 16 + 'px')
		}

		//Prevent the H4 underline changing length
		$h4.css('max-width', $h4.width() + 'px').css('min-width', $h4.width() + 'px');
	});

	$(window).on('scroll', function () {
		for (let i = 0; i < elements.length; i++) {
			if (!elements[i].started && elements[i].top - $(window).scrollTop() - $(window).height() < 0) {
				elements[i].started = true;
				animate($(elements[i].elem));
			}

			if (elements[i].started && elements[i].top - $(window).scrollTop() - $(window).height() > 50) {
				elements[i].started = false;
			}
		}
	});
});


function animate(e) {
	let start = Number($(e).data('start'));
	let end = Number($(e).data('end'));
	let maxFractionDigits = Number($(e).data('digits'));
	let height = Number($(e).data('height'));
	let duration = Number($(e).data('duration'));
	let bg = $(e).find('.bg');
	let span = $(e).find('.h4 span');
	let noFormat = $(e).data('noformat')=='True';

	const heightStep = height / duration;
	const numberStep = (end - start) / duration;

	$(span).text(start.toLocaleString());

	for (let i = 0; i <= duration; i++) {
		window.setTimeout(function () {
			if (Foundation.MediaQuery.atLeast('medium')) {
				$(bg).css('height', (i * heightStep) + '%');
			}
			if (noFormat) {
				$(span).text(Math.round(start + (i * numberStep)));
			} else {
				$(span).text((start + (i * numberStep)).toLocaleString('en', {
					maximumFractionDigits: maxFractionDigits
				}));
			}
		}, i);
	}
}